import { render, staticRenderFns } from "./AirportList.vue?vue&type=template&id=128d1f9f&scoped=true&"
import script from "./AirportList.vue?vue&type=script&lang=js&"
export * from "./AirportList.vue?vue&type=script&lang=js&"
import style0 from "./AirportList.vue?vue&type=style&index=0&id=128d1f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d1f9f",
  null
  
)

export default component.exports